import React, { useEffect, useState } from 'react';
import './dar-list.scss';
import AdminPage from '../../../components/common/page/AdminPage';
import TableFilter from '../../../components/common/table-filter/TableFilter';
import { servicedAxios } from '../../../config/axios';
import Spinner from '../../../components/common/spinners/SpinWithMessage'
import { MdOutlineMiscellaneousServices } from "react-icons/md";
import { FaEye, FaCheckCircle } from 'react-icons/fa'
import { useLocation, useNavigate } from 'react-router-dom';
import { generateServiceDarReport } from '../../../assets/javascript/report-helper';
import { formatIndianAmount, getTimeFromSecond } from '../../../assets/javascript/formate-functions';

const ServicedList = () => {

    const location = useLocation()
    const [darList, setDarList] = useState([])
    const [loading, setLoading] = useState(true)
    const [report, setReport] = useState({})
    const navigate = useNavigate()


    useEffect(() => {
        if (!location?.state) {
            navigate('/admin')
        }

        setLoading(true)
        servicedAxios.get(`/dar/tech-basie?tech_id=${location?.state?.tech_id}&from_date=${location?.state?.from_date}&to_date=${location?.state?.end_date}`)
            .then((response) => {
                setDarList(response.data)
                setReport(generateServiceDarReport(response.data) || {})
                setLoading(false)
            })
        // eslint-disable-next-line
    }, [])


    return (
        <div className="dar-list-div">
            <AdminPage titleArray={['DAR List']}>
                <div className="info-table">
                    <p>{location?.state?.from_date} - {location?.state?.end_date}</p>
                    <p>{location?.state?.tech_name}</p>
                </div>
                {!loading && <div className="report-div">
                    <div className="report-one-div">
                        <div className="item-div">
                            <h2>{report?.all_works || 0}</h2>
                            <p>Works</p>
                        </div>
                        <div className="item-div">
                            <h2>₹ {formatIndianAmount(report?.revenue || 0)}</h2>
                            <p>Revenue</p>
                        </div>
                        <div className="item-div">
                            <h2>₹ {formatIndianAmount(report?.spare_amount || 0)}</h2>
                            <p>Spare amount</p>
                        </div>
                        <div className="item-div">
                            <h2>{report?.call || 0}</h2>
                            <p>Calls</p>
                        </div>
                    </div>
                   
                    <div className="report-two-div">
                        <div className="item-div">
                            <h4>Renewals</h4>
                            <table>
                                <tr>
                                    <th>Type</th>
                                    <th>Count</th>
                                    <th>Tot. Time</th>
                                    <th>Avg. Time</th>
                                </tr>
                                <tr>
                                    <td>AMC</td>
                                    <td>{report?.renewals?.amc?.count || 0}</td>
                                    <td>{getTimeFromSecond(report?.renewals?.amc?.total_time)}</td>
                                    <td>{getTimeFromSecond(report?.renewals?.amc?.total_time / (report?.renewals?.amc?.count || 0)) || 0}</td>
                                </tr>
                                <tr>
                                    <td>SSP</td>
                                    <td>{report?.renewals?.ssp?.count || 0}</td>
                                    <td>{getTimeFromSecond(report?.renewals?.ssp?.total_time)}</td>
                                    <td>{getTimeFromSecond(report?.renewals?.ssp?.total_time / (report?.renewals?.ssp?.count || 0)) || 0}</td>
                                </tr>
                            </table>
                        </div>
                        <div className="item-div">
                            <h4>Services</h4>
                            <table>
                                <tr>
                                    <th>Type</th>
                                    <th>Count</th>
                                    <th>Tot. Time</th>
                                    <th>Avg. Time</th>
                                </tr>
                                <tr>
                                    <td>AMC</td>
                                    <td>{report?.services?.amc?.count || 0}</td>
                                    <td>{getTimeFromSecond(report?.services?.amc?.total_time)}</td>
                                    <td>{getTimeFromSecond(report?.services?.amc?.total_time / (report?.services?.amc?.count || 0) || 0)}</td>
                                </tr>
                                <tr>
                                    <td>SSP</td>
                                    <td>{report?.services?.ssp?.count || 0}</td>
                                    <td>{getTimeFromSecond(report?.services?.ssp?.total_time)}</td>
                                    <td>{getTimeFromSecond(report?.services?.ssp?.total_time / (report?.services?.ssp?.count || 0) || 0)}</td>
                                </tr>
                                <tr>
                                    <td>I/W</td>
                                    <td>{report?.services?.iw?.count || 0}</td>
                                    <td>{getTimeFromSecond(report?.services?.iw?.total_time)}</td>
                                    <td>{getTimeFromSecond(report?.services?.iw?.total_time / (report?.services?.iw?.count || 0) || 0)}</td>
                                </tr>
                                <tr>
                                    <td>O/W</td>
                                    <td>{report?.services?.ow?.count || 0}</td>
                                    <td>{getTimeFromSecond(report?.services?.ow?.total_time)}</td>
                                    <td>{getTimeFromSecond(report?.services?.ow?.total_time / (report?.services?.ow?.count || 0) || 0)}</td>
                                </tr>
                                <tr>
                                    <td>O/C</td>
                                    <td>{report?.services?.oc?.count || 0}</td>
                                    <td>{getTimeFromSecond(report?.services?.oc?.total_time)}</td>
                                    <td>{getTimeFromSecond(report?.services?.oc?.total_time / (report?.services?.oc?.count || 0) || 0)}</td>
                                </tr>
                            </table>
                        </div>
                        <div className="item-div">
                            <h4>Complaints</h4>
                            <table>
                                <tr>
                                    <th>Type</th>
                                    <th>Count</th>
                                    <th>Tot. Time</th>
                                    <th>Avg. Time</th>
                                </tr>
                                <tr>
                                    <td>AMC</td>
                                    <td>{report?.complaints?.amc?.count || 0}</td>
                                    <td>{getTimeFromSecond(report?.complaints?.amc?.total_time)}</td>
                                    <td>{getTimeFromSecond(report?.complaints?.amc?.total_time / (report?.complaints?.amc?.count || 0) || 0)}</td>
                                </tr>
                                <tr>
                                    <td>SSP</td>
                                    <td>{report?.complaints?.ssp?.count || 0}</td>
                                    <td>{getTimeFromSecond(report?.complaints?.ssp?.total_time)}</td>
                                    <td>{getTimeFromSecond(report?.complaints?.ssp?.total_time / (report?.complaints?.ssp?.count || 0) || 0)}</td>
                                </tr>
                                <tr>
                                    <td>I/W</td>
                                    <td>{report?.complaints?.iw?.count || 0}</td>
                                    <td>{getTimeFromSecond(report?.complaints?.iw?.total_time)}</td>
                                    <td>{getTimeFromSecond(report?.complaints?.iw?.total_time / (report?.complaints?.iw?.count || 0) || 0)}</td>
                                </tr>
                                <tr>
                                    <td>O/W</td>
                                    <td>{report?.complaints?.ow?.count || 0}</td>
                                    <td>{getTimeFromSecond(report?.complaints?.ow?.total_time)}</td>
                                    <td>{getTimeFromSecond(report?.complaints?.ow?.total_time / (report?.complaints?.ow?.count || 0) || 0)}</td>
                                </tr>
                                <tr>
                                    <td>O/C</td>
                                    <td>{report?.complaints?.oc?.count || 0}</td>
                                    <td>{getTimeFromSecond(report?.complaints?.oc?.total_time)}</td>
                                    <td>{getTimeFromSecond(report?.complaints?.oc?.total_time / (report?.complaints?.oc?.count || 0) || 0)}</td>
                                </tr>
                            </table>
                        </div>
                        <div className="item-div">
                            <table>
                                <tr>
                                    <td>Repeats</td>
                                    <td>{report?.repeat_works || 0}</td>
                                </tr>
                                <tr>
                                    <td>Above 24</td>
                                    <td>{report?.above_24_works || 0}</td>
                                </tr>
                                <tr>
                                    <td>Extra works</td>
                                    <td>{report?.extra_works || 0}</td>
                                </tr>
                                <tr>
                                    <td>Tot Working Time</td>
                                    <td>{getTimeFromSecond(report?.working_time)}</td>
                                </tr>
                                <tr>
                                    <td>Avg Working Time</td>
                                    <td>{getTimeFromSecond(report?.working_time / report?.all_works || 0)}</td>
                                </tr>
                                <tr>
                                    <td>Avg Call</td>
                                    <td>{parseFloat(report?.call / report?.all_works || 0).toFixed(1)}</td>
                                </tr>
                                <tr>
                                    <td>Call Reach / hr</td>
                                    <td>{parseFloat(report?.call / Math.floor(report?.working_time / 3600) || 0).toFixed(1)}</td>
                                </tr>
                            </table>
                        </div>
                    </div>
                </div>}
                {darList?.[0] ?
                    <TableFilter>
                        <table>
                            <thead>
                                <tr>
                                    <th>Date</th>
                                    <th>CID / <br></br>Customer Name</th>
                                    <th>Technician / City </th>
                                    <th>IN / OUT</th>
                                    <th>Work</th>
                                    <th>Srl Number</th>
                                    <th>Call</th>
                                    <th>Amount</th>
                                    <th>Action</th>
                                </tr>
                            </thead>
                            <tbody>
                                {darList.map((service, index) => <tr key={index}>
                                    <td style={{ textAlign: "center" }}>{service?.date}</td>
                                    <td style={{ textAlign: "center" }}>CID : {service?.cid}<br></br>{service?.name_of_customer}</td>
                                    <td style={{ textAlign: "center" }}>{service?.technician} <br></br>{service?.post} / {service?.city_name} City</td>
                                    <td style={{ textAlign: "center" }}>
                                        IN - {new Date(service?.in_time).toLocaleTimeString()}
                                        <br></br>
                                        OUT - {new Date(service?.out_time).toLocaleTimeString()}
                                    </td>
                                    <td style={{ textAlign: "center" }}>
                                        <span className={`text-badge ${service?.purifier_customer_status}-text`}>{service?.purifier_customer_status}</span>
                                        <br></br>
                                        {service?.work_method}
                                    </td>
                                    <td style={{ textAlign: "center" }}>
                                        {service?.service_srl_number}
                                        <br></br>
                                        {service?.repeat && <span className={`text-badge red-text`}>Repeat</span>}
                                    </td>
                                    <td style={{ textAlign: "center" }}>
                                        {service?.call_details?.primary_secondary ? <>Normal : {service?.call_details?.primary_secondary}<br /></> : null}
                                        {service?.call_details?.extra_work ? <>Extra : {service?.call_details?.extra_work}<br /></> : null}
                                        {service?.call_details?.above_24_kms ? <>Above 24 : {service?.call_details?.above_24_kms}</> : null}
                                    </td>
                                    <td style={{ textAlign: "center" }}>₹{service?.total_amount} {!service?.balance_amount && <span style={{ color: 'green' }}><FaCheckCircle /></span>}</td>
                                    <td style={{ textAlign: "center" }}>
                                        <div className='buttons' >
                                            <button title='View service' className='button-small-icon edit'
                                                onClick={() => navigate(`/admin/serviced-list/${service?.service_srl_number}/view`)}><FaEye /></button>
                                        </div>
                                    </td>
                                </tr>)}

                            </tbody>
                        </table>
                    </TableFilter>
                    : <Spinner message={loading ? 'Fetch data..' : 'No services'} spin={loading} icon={!loading && <MdOutlineMiscellaneousServices />} />}
            </AdminPage>
        </div>
    )
}

export default ServicedList